export async function clinvar(path, body) {
    const response = await fetch(`/api/clinvar${path}`, body === undefined ? {} : {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    })
    const data = await response.json()
    if (!response.ok) throw new Error(data.message || 'ClinVar-Anfrage fehlgeschlagen.')
    return data
}
